var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconBrandTicket(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m18.642 2.388 2.697 1.315 2.521 6.236 6.467-1.852.139.067-7.212 5.603-.82.314-3.31-8.11-2.695-1.315L3.716 30.71l4.186 2.041 4.083 5.33-8.925-4.353c-1.853-.904-2.592-3.202-1.651-5.132L13.342 4.13c.942-1.93 3.447-2.646 5.3-1.742zm17.681 7.844 1.847 2.364-.468 6.71 6.625 1.17 1.847 2.364c1.269 1.625 1.09 4.224-.602 5.546L24.12 45.146c-1.692 1.322-4.093 1.077-5.363-.547L8.578 31.57c-1.269-1.625-.926-4.014.766-5.336l21.452-16.76c1.692-1.322 4.258-.867 5.527.758zm-2.98 1.059L10.491 29.145 21.573 43.33l22.852-17.854-1.847-2.364-8.045-1.328.657-8.128-1.847-2.364zm-8.75 11.941 6.601.694a.5.5 0 0 1 .445.55l-.694 6.6a.5.5 0 0 1-.55.445l-4.068-.427a.5.5 0 0 1-.445-.55l.162-1.537a.5.5 0 0 0-.445-.55l-1.538-.161a.5.5 0 0 1-.445-.55l.428-4.069a.5.5 0 0 1 .55-.445z",
    fill: "#E10A0A",
    fillRule: "evenodd"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBrandTicket);
export default __webpack_public_path__ + "static/media/icon-brand-ticket.0a9ce15a71ef7c4ca31d0f880f982f07.svg";
export { ForwardRef as ReactComponent };